module.exports = "/static/assets/75dfdd77f40989c76f8be89442c48f57.png";